export const getOrdinalSuffix = (num: number): string => {
  const pluralRule = new Intl.PluralRules('en-GB', { type: 'ordinal' });
  const suffixes = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th',
  };

  return suffixes[pluralRule.select(num)];
};

export const isNumber = (val: string | number) => Number.isInteger(Number(val));

export const isBetween = (val: number, start: number, end: number) => val >= start && val <= end;
